export const ActiveWhiteLabelActionButton = () => {
  return (
    <button className="rounded-lg bg-[#FFEAEA] px-6 py-2 font-medium text-[#B21515]">
      Block User
    </button>
  );
};
